<template>
    <div>
        <!-- <div class="banner">
            <img :src="require('../../../../assets/img/case/case_banner.png')" />
        </div> -->
        <el-carousel :interval="5000" arrow="hover" indicator-position="none" style="width: 100%;" :height="height">
            <el-carousel-item v-for="item in imgList" :key="item">
                <img :src="item" alt="bannner图" />
            </el-carousel-item>
        </el-carousel>

        <div class="menu">
            <el-menu :default-active="currentIndex.toString()" class="nav clearfix" mode="horizontal">
                <el-menu-item :index="index.toString()" @click="jumpPage('/case/' + (index + 1))" class="cursor-pointer"
                    v-for="(item, index) in caseList" :key="index">
                    <img :src="require('../../../../assets/img/case/icon/icon_'+item.icon+'_check.png')" class="icon"
                        v-if="currentIndex==index"></img>
                    <img :src="require('../../../../assets/img/case/icon/icon_'+item.icon+'_default.png')" class="icon"
                        v-else></img>
                    {{ item.name }}
                </el-menu-item>
            </el-menu>
        </div>

        <zhinengzhizao v-if="currentIndex==1"></zhinengzhizao>
        <yiyao v-else-if="currentIndex==2"></yiyao>
        <shangye v-else-if="currentIndex==3"></shangye>
        <jiaoyu v-else-if="currentIndex==4"></jiaoyu>
        <yancao v-else-if="currentIndex==5"></yancao>
        <bandaoti v-else></bandaoti>
    </div>
</template>

<script>
import bandaoti from './caseDetail/bandaoti.vue';
import zhinengzhizao from './caseDetail/zhinengzhizao.vue';
import yiyao from './caseDetail/yiyao.vue';
import shangye from './caseDetail/shangye.vue';
import jiaoyu from './caseDetail/jiaoyu.vue';
import yancao from './caseDetail/yancao.vue';
export default {
    components:{
        bandaoti,
        zhinengzhizao,
        yiyao,
        shangye,
        jiaoyu,
        yancao
    },
    props: ['id'],
    data(){
        return {
            currentIndex:0,
            caseList:[{name:'半导体',icon:'bandaoti'},{name:'智能制造',icon:'zhinengzhizao'},{name:'医药',icon:'yiyao'},{name:'商业',icon:'shangye'},{name:'教育',icon:'jiaoyu'},{name:'烟草',icon:'yancao'}],
            autoSwitchCaseTimer: null, // 自动切换产品定时器
            autoSwitchCaseInterval: 10000, // 切换间隔（10秒）
            isAtTop: true,
            imgList: [
                require('../../../../assets/img/case/case_banner1.png'),
                require('../../../../assets/img/case/case_banner2.png'),
            ],
            height:0
        }
    },
    methods:{
        isNumber(value) {
            if (typeof value === 'number') {
                return !isNaN(value);
            }
            if (typeof value === 'string') {
                const trimmed = value.trim();
                return !isNaN(trimmed) && isFinite(trimmed);
            }
            return false;
        },
        jumpPage(url) {
            this.$router.push(url)
        },
        startAutoSwitchCase(){
            if (this.caseList.length <= 1) return; // 如果菜单项少于2个，不启动自动切换
            this.autoSwitchCaseTimer = setInterval(() => {
                if(this.isAtTop)
                    this.currentIndex = (this.currentIndex + 1) % this.caseList.length;
            }, this.autoSwitchCaseInterval);
        },
        stopAutoSwitchCase() {
            if (this.autoSwitchCaseTimer) {
                clearInterval(this.autoSwitchCaseTimer);
                this.autoSwitchCaseTimer = null;
            }
        },
        handleScroll() {
            // 获取当前滚动位置
            const scrollPosition = window.scrollY || document.documentElement.scrollTop;

            // 判断是否滚动到顶部
            this.isAtTop = scrollPosition === 0;
        }
    },
    mounted() {
        if(this.id&&this.isNumber(this.id)&&this.id>0&&this.id<=this.caseList.length)
            this.currentIndex=(this.id-1)

        // 页面加载后启动项目案例自动切换
        this.startAutoSwitchCase();

        // 添加滚动事件监听
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        // 组件销毁时清除定时器
        this.stopAutoSwitchCase();

        // 移除滚动事件监听，避免内存泄漏
        window.removeEventListener('scroll', this.handleScroll);
    },
    created() {
        let deviceWidth = document.documentElement.clientWidth
        this.height = deviceWidth * 495 / 1912 + 'px'
    }
};
</script>

<style lang="less" scoped>
@import '@/assets/css/case.less';
</style>